/**
 * Created by paulhudson on 24/04/2017.
 */
export class ApplyNow {
  jobid: number;
  name: string;
  email: string;
  phone: string;
  file: object;
  gdpr: number;

  constructor() {  }
}



// WEBPACK FOOTER //
// ./src/app/apply-now.ts